import { render, staticRenderFns } from "./StatementMonthData.vue?vue&type=template&id=39b4bc52&scoped=true"
import script from "./StatementMonthData.vue?vue&type=script&lang=js"
export * from "./StatementMonthData.vue?vue&type=script&lang=js"
import style0 from "./StatementMonthData.vue?vue&type=style&index=0&id=39b4bc52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b4bc52",
  null
  
)

export default component.exports